module.exports = __webpack_public_path__ + "static/portrait.d926958a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portrait.jpg
// module id = 1156
// module chunks = 35783957827783